import EditButton from "./EditButton";
import "./EditButtonGroup.scss";

// static: if true, renders as static; otherwise floating (default)
// className: optional extra classes (e.g., "image-edit-buttons")
// editText: optional custom label for the edit button (defaults to "Edit")
// onEdit: click handler for edit
// showUndo: whether to render the Undo button
// onUndo: click handler for undo

const EditButtonGroup = ({
	static: isStatic = false,
	className = "",
	editText,
	onEdit,
	showUndo = false,
	onUndo
}) => {
	const baseClass = isStatic ? "static-edit-buttons" : "floating-edit-buttons";
	const containerClass = className ? baseClass + " " + className : baseClass;

	return (
		<div className={containerClass}>
			<EditButton onClick={onEdit} text={editText} />
			{showUndo && <EditButton undo onClick={onUndo} />}
		</div>
	);
};

export default EditButtonGroup;
